import "./style.scss";
import $ from 'jquery';

$('.load-more-files a').on('click', function (event) {
    event.preventDefault();

    const anchor = $("#yearly-reports");
    const children = anchor.children();
    const defaultNumPerPage = parseInt(anchor.attr("default-files"));
    const maxFiles = parseInt(anchor.attr("max-files"));
    const numOfPages = parseInt(anchor.attr("num-of-pages"));

    anchor.attr("num-of-pages", numOfPages - 1);
    if (numOfPages === 1) {
        $(this).parent().hide();
    }

    children.each(function (index) {
        if (index < (maxFiles + defaultNumPerPage)) {
            $(this).removeClass("hide").addClass("show");
        }
    });

    anchor.attr("max-files", maxFiles + defaultNumPerPage);
});